import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import ProductDetails from '../product-details';
import { MediaQuery as MQ } from '../../../shared/media-query';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = { width: window.innerWidth };
    }

    componentDidMount() {
        this.props.requireState(this.props.upc);
        this.mainExpandedVip();
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.description != this.props.description) {
            return true;
        }

        if (nextProps.product != this.props.product) {
            return true;
        }

        if (nextState.width >= 600 && this.state.width < 600) {
            return true;
        }

        if (nextState.width < 600 && this.state.width >= 600) {
            return true;
        }

        return false;
    }

    render({ description }) {
        if (description && description.code) {
            if (description.code == 'forecast-monthly-subscription') {
                return (
                    <subscription-teeup upc={this.props.upc}>
                        {this.renderVipContent()}
                    </subscription-teeup>
                );

            }

            return (
                <subscription-teeup upc={this.props.upc}>
                    <p className='price'>
                        {this.renderSalePrice()}
                        <span>{this.renderPrice()} Per Month</span>
                    </p>
                    <header>
                        <div className='icon-teeup' />
                        <h1 className='fancy-title'>{description.product_name}</h1>
                        <ProductDetails summary={description.subheader} details={description.long_description} />
                    </header>
                    <row className='is-wrap'>
                        <column className='is-3 is-12-mobile has-text-center has-margin-10-bottom has-padding-10'>
                            <img
                                className='icon'
                                alt='Daily Reflection Tarot Subscription Benefit 1'
                                src='https://gfx.tarot.com/images/subscriptions/drt/icon1.svg'
                            />
                            <br />
                            <h5>TRIPLE THE INSIGHT</h5>
                            <h5>
                                You’ll save over $140 every month by receiving three daily Tarot readings for the
                                price of one!
                            </h5>
                        </column>
                        <column className='is-3 is-12-mobile has-text-center has-margin-10-bottom has-padding-10'>
                            <img
                                className='icon'
                                alt='Daily Reflection Tarot Subscription Benefit 4'
                                src='https://gfx.tarot.com/images/subscriptions/drt/icon4.svg'
                            />
                            <br />
                            <h5>STAY ON TRACK</h5>
                            <h5>
                                Each reading is saved in your journal, so you can easily reflect on and track your
                                progress.
                            </h5>
                        </column>
                        <column className='is-3 is-12-mobile has-text-center has-margin-10-bottom has-padding-10'>
                            <img
                                className='icon'
                                alt='Daily Reflection Tarot Subscription Benefit 2'
                                src='https://gfx.tarot.com/images/subscriptions/drt/icon2.svg'
                            />
                            <br />
                            <h5>DAILY DOSE OF WISDOM</h5>
                            <h5>Set daily intentions and get quick insight on what’s happening in the moment.</h5>
                        </column>
                        <column className='is-3 is-12-mobile has-text-center has-margin-10-bottom has-padding-10'>
                            <img
                                className='icon'
                                alt='Daily Reflection Tarot Subscription Benefit 3'
                                src='https://gfx.tarot.com/images/subscriptions/drt/icon3.svg'
                            />
                            <br />
                            <h5>TAROT ON THE GO</h5>
                            <h5>Get insight anytime, anywhere! You can access your reading from any device.</h5>
                        </column>
                    </row>
                    {this.renderButton('PURCHASE SUBSCRIPTION', 'drts')}
                </subscription-teeup>
            );
        }

        return (<subscription-teeup />);
    }

    mainExpandedVip = () => {
        if (this.props.upc == 'forecast-monthly-subscription') {
            const main = document.getElementsByTagName('main')[0];
            main.classList.add('expanded');
        }
    };

    renderVipContent = () => {
        return [
            this.renderTopImg(),
            <div className='content-container'>
                <row className='is-justified-center has-text-center has-margin-5-mobile'>
                    <column>
                        <h1 className='fancy-title'>Become a VIP</h1>
                        <p>
                            Get an enhanced, personalized experience on Tarot.com! Here's what you'll get:
                        </p>
                    </column>
                </row>
                {this.renderBenefits()}
                <row className='is-justified-center has-text-center'>
                    <column>
                        {this.renderButton('START MY FREE TRIAL*', 'vip-button')}
                        <p className='has-text-boulder'>
                            *7-day free trial then {this.renderSalePrice()} <span>{this.renderPrice()} per month</span>
                            <br /><i>A $20 Value!</i>
                        </p>
                    </column>
                </row>
            </div>,
        ];
    }

    renderTopImg = () => {
        if (MQ.isMobile()) {
            return <img
                src='https://gfx.tarot.com/images/site/membership/vip-header-m.jpg'
                className='is-visible-mobile lazyload is-full-width'
                height='160'
                width='1200'
                alt='Vip membership banner image'
            />;
        }

        return <img
            src='https://gfx.tarot.com/images/site/membership/vip-header-d.jpg'
            className='is-hidden-mobile lazyload is-full-width'
            height='104'
            width='380'
            alt='Vip membership banner image'
        />;
    };

    renderBenefits = () => {
        if (MQ.isMobile()) {
            return (
                <div className='is-carousel is-visible-mobile'>
                    <div className='is-carousel-card'>
                        {this.renderImg(0)}
                        {this.renderBenefitList(0)}
                    </div>
                    <div className='is-carousel-card'>
                        {this.renderImg(1)}
                        {this.renderBenefitList(4)}
                    </div>
                    <div className='is-carousel-card'>
                        {this.renderImg(2)}
                        {this.renderBenefitList(8)}
                    </div>
                </div>
            );
        }

        return (
            <row className='is-hidden-mobile has-margin-10-right'>
                <column className='is-4 has-padding-40-left'>
                    {this.renderImg(0, 'center')}
                    {this.renderBenefitList(0)}
                </column>
                <column className='is-4 has-padding-10-left'>
                    {this.renderImg(1, 'center')}
                    {this.renderBenefitList(4)}
                </column>
                <column className='is-4 has-padding-10-left'>
                    {this.renderImg(2, 'center')}
                    {this.renderBenefitList(8)}
                </column>
            </row>
        );
    };

    renderSalePrice = () => {
        if (this.props.product.price && this.props.product.price.usd.current < this.props.product.price.usd.original) {
            return (<s>${this.props.product.price.usd.original.toFixed(2)}</s>);
        }

        return null;
    }

    renderPrice = () => {
        if (this.props.product.price) {
            return `$${this.props.product.price.usd.current.toFixed(2)}`;
        }

        return null;
    }

    renderBenefitList = (index) => {
        const benefitsArray = [
            'Free Premium Tarot Readings',
            'A premium reading every month',
            '40+ readings to choose from',
            'Immediate answers and advice',
            'Personalized Astrology Everyday',
            'Daily energies uniquely impacting YOU',
            'Advice specific to the day’s vibrations',
            'Access to a whole month at once',
            'Exclusive<br />Perks',
            'First access to new readings',
            'Ad-free experience on daily content',
            'Sneak peaks at upcoming features',
        ];

        return [
            <h3
                className='has-margin-20-bottom has-text-center has-text-left-mobile'
                dangerouslySetInnerHTML={{__html: benefitsArray[index]}}
            />,
            <ul className='benefits-detail has-list-style-none'>
                {benefitsArray.slice(index + 1, index + 4).map((benefit) =>
                    <li>
                        <row>
                            <column className='is-hidden-mobile has-text-eminence has-padding-5-right'>◆</column>
                            <column className={`has-padding-${index == '4' ? '20' : '25'}-right-mobile`}>
                                <span dangerouslySetInnerHTML={{__html: benefit}} />
                            </column>
                        </row>
                    </li>
                )}
                <li
                    className='is-h3 has-text-vivid-violet is-visible-mobile'
                    onClick={(e) => this.submit(e, `vip-${index+1}`)}
                >
                    Join Now!
                </li>
            </ul>,
        ];
    }

    renderButton = (buttonText, label) => {
        return (
            <form onSubmit={(e) => this.submit(e, label)}>
                <div className={`
                    has-margin-20 has-text-center${buttonText == 'GET VIP ACCESS NOW' ? '-mobile has-text-left' : ''}
                `}>
                    <button className='button-daisy-bush'>
                        {this.props.product.submitting ? 'submitting…' : buttonText}
                    </button>
                    {this.renderError()}
                </div>
            </form>
        );
    }

    renderImg = (index, justified) => {
        const imgs = [
            ['free', 'tarot reading icon', '60', '60'],
            ['astrology', 'personalized astrology icon', '60', '60'],
            ['perks', 'exclusive perks icon', '60', '60'],
        ];

        return (
            <img
                src={`https://gfx.tarot.com/images/site/membership/${imgs[index][0]}.svg`}
                alt={imgs[index][1]}
                width={imgs[index][2]}
                height={imgs[index][3]}
                className={`lazyload has-cursor-pointer is-block
                    ${justified == 'center' ? 'has-margin-auto ' : ''}has-padding-15-bottom`}
                onClick={(e) => this.submit(e, `vip-${index+1}-img`)}
            />
        );
    }

    renderError = () => {
        if (this.props.product.error) {
            return (<p className='error'>{this.props.product.error}</p>);
        }

        return null;
    }

    submit = (e, label) => {
        e.preventDefault();

        if (label != 'drts') {
            this.props.trackEvent(['VIP Teeup', this.props.logged_in ? 'LI Click' : 'LO Click', label]);
            this.props.trackPromo(['VIP Teeup', label]);
        }

        this.props.submit();
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    }
}

const mapStateToProps = (state) => ({
    description: state.product && state.product.description,
    product: state.product,
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    requireState: (upc) => dispatch({ type: 'subscription:init', payload: upc }),
    submit: () => dispatch({ type: 'product:submit' }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: (payload) => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
